const recommendDOTD = function(){
	const accordions = new getAccordions4i();
	const helpers = new formHelpers4i();
	const forms = new forms4i();
	let submitBtn, recForm, recaptchaSiteKey, recaptchaActionName;
	
	const init = () => {
		getRecommendPanel();
	},
	getRecommendPanel = async () => {
		let panelHTML;
		try{
			const response = await fetch('/dealoftheday/deals/GetRecommend', {
				method: 'GET', 
				headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
			});
			panelHTML = await response.text();
		}catch(error){
			console.error(error);
			// error function here
		}
		
		if(panelHTML && document.getElementById("recommendPnl")){
			document.getElementById("recommendPnl").innerHTML = panelHTML;
			accordions.init(document.getElementById("recommendPnl"));
			setVariables();
			if (submitBtn) submitBtn.addEventListener("click", validate);
		}
	},
	setVariables = () => {
		recForm = document.getElementById("recommendForm");
		submitBtn = document.getElementById("btnSubmitRecommend");
		recaptchaSiteKey = recForm.querySelector("#RecaptchaSiteKeyRecommend").value;
		recaptchaActionName = recForm.querySelector("#recaptchaActionNameRecommend").value;
	},
	validate = (e) => {
		e.preventDefault();
		helpers.ClearStatus();
		helpers.ShowBusyBtn(submitBtn);
		submitBtn.setAttribute("disabled", "disabled");
		forms.formValidation(recForm, submitRecommendForm, e, enableSubmitBtn);
	},
	enableSubmitBtn = () => {
		submitBtn.removeAttribute("disabled");
		helpers.ClearBusyBtn();
	},
	submitRecommendForm = async () => {
		grecaptcha.execute(recaptchaSiteKey, { action: recaptchaActionName }).then(function (token) {
				submitForm(token);
		});
    	},
	submitForm = async (token) => {
		const data = {
			RecipientName: document.getElementById("RecipientName").value,
			RecipientEmail: document.getElementById("RecipientEmail").value,
			SenderName: recForm.querySelector("#SenderName").value,
			SenderEmail: recForm.querySelector("#SenderEmail").value,
			TypeofInsert: document.getElementById("TypeOfInsert").value,
			RecaptchaActionName: recaptchaActionName,
			RecaptchaToken: token
		};
		let responseJSON;
		try{
			const response = await fetch('/dealoftheday/Deals/Recommend', {
				method: 'POST', 
				body: JSON.stringify(data),
				headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
			});
			responseJSON = await response.json();
		}catch(error){
			console.error(error);
			enableSubmitBtn();
			helpers.ShowErrorStatus(submitBtn.parentNode, "There was an error processing your recommendation request. Please try again.");
		}
		
		enableSubmitBtn();

		if(responseJSON){
			if(responseJSON.success){
			    helpers.ShowSuccessStatus(submitBtn.parentNode, responseJSON.message);
				document.getElementById("RecipientName").value = "";
				document.getElementById("RecipientEmail").value = "";
				document.getElementById("recommendForm").querySelector("#SenderName").value = "";
				document.getElementById("recommendForm").querySelector("#SenderEmail").value = "";
			}else{
				helpers.ShowErrorStatus(submitBtn.parentNode, responseJSON.message);
			}
		}
	};
	return{
		Init: init
	};
};

(function(){
	const recommend = new recommendDOTD();
	recommend.Init();
})();